<h2 mat-dialog-title>Select Files to Download</h2>

<mat-dialog-content class="tw-max-h-96 tw-overflow-y-auto">
  <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-mb-4">
    This download has been broken into multiple files. Please select the files you would like to
    download. Selecting multiple files will download them sequentially.
  </p>

  <!-- Select All Checkbox -->
  <div class="tw-mb-4 tw-pb-3 tw-border-b tw-border-gray-200 dark:tw-border-gray-700">
    <mat-checkbox
      [checked]="allSelected"
      (change)="toggleSelectAll()"
      color="primary"
      class="tw-font-medium">
      Select All ({{ selectedCount }} of {{ files.length }} selected)
    </mat-checkbox>
  </div>

  <!-- File List -->
  <div class="tw-space-y-2">
    <div
      *ngFor="let file of files"
      class="tw-p-3 tw-rounded-lg tw-border tw-border-gray-300 dark:tw-border-gray-700 hover:tw-border-gray-400 dark:hover:tw-border-gray-600 tw-transition-all"
      [ngClass]="{
        'tw-bg-blue-50 dark:tw-bg-blue-900/20 tw-border-blue-300 dark:tw-border-blue-700': file.selected
      }">
      <div class="tw-flex tw-items-center">
        <mat-checkbox [(ngModel)]="file.selected" color="primary" class="tw-mr-3"> </mat-checkbox>
        <div class="tw-flex-1 tw-flex tw-items-center">
          <mat-icon class="tw-text-gray-500 dark:tw-text-gray-400 tw-mr-2">description</mat-icon>
          <span class="tw-text-sm tw-text-gray-900 dark:tw-text-gray-100 tw-font-mono tw-break-all">
            {{ file.filename }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Message for Sequential Downloads -->
  <div
    *ngIf="selectedCount > 1"
    class="tw-mt-4 tw-p-3 tw-bg-blue-50 dark:tw-bg-blue-900/20 tw-rounded-lg tw-border tw-border-blue-300 dark:tw-border-blue-700">
    <div class="tw-flex tw-items-center">
      <mat-icon class="tw-text-blue-600 dark:tw-text-blue-400 tw-mr-2 tw-mt-0.5 tw-leading-5"
        >info</mat-icon
      >
      <p class="tw-text-sm tw-text-blue-800 dark:tw-text-blue-200">
        Your browser may prompt you to allow multiple downloads.
      </p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="selectedCount === 0" (click)="onDownload()">
    Download {{ selectedCount > 0 ? '(' + selectedCount + ')' : '' }}
  </button>
</mat-dialog-actions>
